import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../../core/services/helpers.service';
import { FileService } from '../../../../core/api/file.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { UserService } from '../../../../core/api/user.service';
import moment from 'moment';

@Component({
  selector: 'app-view-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-profile.component.html',
  styleUrl: './view-profile.component.scss',
})
export class ViewProfileComponent {
  id: any;
  profileData: any = null;
  imageUrl: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private router: Router,
    private service: UserService,
    private fileService: FileService,
    private loadingService: LoadingService
  ) {
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.loadingService.startLoading();
    this.getDataById().finally(() => {
      this.loadingService.endLoading();
    });
  }

  getDataById(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.id) {
        resolve();
        return;
      }

      this.service.getById(this.id).then(
        (data: any) => {
          this.profileData = data;
          if (data?.file?.id) {
            this.loadingService.startLoading();
            this.fileService.download(data.file.id).subscribe(
              (res: any) => {
                this.loadingService.endLoading();
                this.imageUrl = URL.createObjectURL(res);
              },
              () => {
                this.loadingService.endLoading();
              }
            );
          }
          resolve();
        },
        (error: any) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getFullName(): string {
    const firstName = this.profileData?.firstName ?? '';
    const lastName = this.profileData?.lastName ?? '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || 'Profil pengguna';
  }

  getRolesLabel(): string {
    if (!this.profileData?.userRoles?.length) return '-';
    return this.profileData.userRoles
      .map((item: any) => item?.role?.name)
      .filter(Boolean)
      .join(', ');
  }

  formatDate(value: any): string {
    if (!value) return '-';
    const parsed = moment(value);
    return parsed.isValid() ? parsed.format('D MMMM YYYY') : '-';
  }

  goBack(): void {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    this.router.navigate(['/dashboard']);
  }
}
